import { Component, OnInit } from '@angular/core';
import { ASSETS_PATH } from 'src/app/core/config';
import { EDUCATION_TYPES } from 'src/app/core/models/enum.model';
import { UserBasicInfo } from 'src/app/core/models/user.model';
import { AlertService } from 'src/app/core/services/alert.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { LoadingService } from 'src/app/core/services/loading.service';
import { UserService } from 'src/app/core/services/user.service';

declare const $: any;
@Component({
  selector: 'app-my-profile',
  templateUrl: './my-profile.component.html',
  styleUrls: ['./my-profile.component.scss']
})
export class MyProfileComponent implements OnInit {

  userBasicInfo = new UserBasicInfo();
  educationList = [];
  professionList = [];
  educationLevels = EDUCATION_TYPES;
  assetsPath = ASSETS_PATH;
  isImage = false;

  constructor(private alertService: AlertService,
    private authService: AuthService,
    private userService: UserService,
    private loadingService: LoadingService) { }

  ngOnInit(): void {
    this.loadingService.setLoading(true);
    this.userService.getUserBasicInfo().subscribe(response => {
      if (response.success) {
        this.userBasicInfo = response;
        console.log(this.userBasicInfo);
        if (this.userBasicInfo.image !== null && this.userBasicInfo.image !== "") {
          this.isImage = true;
        }
        this.loadingService.setLoading(false);
      }
    },
      (error) => {
        this.loadingService.setLoading(false);
        this.alertService.alert('Hata!', error.error.Message, 'error');
        console.log('Error --->:', error);
      });
    this.getEducationList();
    this.getProfessionList();
  }

  getEducationList() {
    this.loadingService.setLoading(true);
    this.userService.getUserEducationInfo().subscribe(response => {
      if (response.success) {
        this.educationList = response.schoolList;
        console.log(this.educationList);
        this.loadingService.setLoading(false);
      }
    },
      (error) => {
        this.loadingService.setLoading(false);
        this.alertService.alert('Hata!', error.error.Message, 'error');
        console.log('Error --->:', error);
      });
  }

  getProfessionList() {
    this.loadingService.setLoading(true);
    this.userService.getUserProfessionInfo().subscribe(response => {
      if (response.success) {
        this.professionList = response.professionList;
        console.log(this.professionList);
        this.loadingService.setLoading(false);
      }
    },
      (error) => {
        this.loadingService.setLoading(false);
        this.alertService.alert('Hata!', error.error.Message, 'error');
        console.log('Error --->:', error);
      });
  }

  getEducationLevel(status: number) {
    if (status === undefined || status === null) {
      return "";
    }
    let value = this.educationLevels.filter(x => x.code === status);

    if (value !== undefined && value !== null) {
      try {
        return value[0].text;
      }
      catch {
        return "";
      }
    }
  }

  deleteMyAccount() {
    this.userService.deleteMyUser().subscribe(response => {
      if (response.success) {
        $('#reminder').modal('hide');
        this.alertService.alert("Başarılı!", "Hesabınız başarıyla silindi!", "success");
        this.authService.logout();
      }
    },
      (error) => {
        this.loadingService.setLoading(false);
        this.alertService.alert('Hata!', error.error.Message, 'error');
      });
  }

  showReminderModal() {
    $('#reminder').modal('show')
  }

  hideReminderModal() {
    $('#reminder').modal('hide');
  }

  sendActivationCode() {
    this.loadingService.setLoading(true);
    this.userService.sendActivation().subscribe(response => {
      if (response.success) {
        this.alertService.alert("Başarılı!", "Aktifleştirme maili gönderildi! Lütfen mailinizi kontrol ediniz.", "success");
        this.loadingService.setLoading(false);
      }
    },
      (error) => {
        this.loadingService.setLoading(false);
        this.alertService.alert('Hata!', error.error.Message, 'error');
      });
  }
}
